import type { IconData } from '@stacksjs/iconify-core'

export const ml1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\"><path fill=\"red\" d=\"M340.6 0H512v512H340.6z\"/><path fill=\"#009a00\" d=\"M0 0h170.3v512H0z\"/><path fill=\"#ff0\" d=\"M170.3 0h171.2v512H170.3z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ml1x1
